<img routerLink="" src="https://cdn2.tda.website/beehive/20201123/Eastward-Logo-Png-white-4x.png?h=25&auto=format" alt="Eastward Missions Australia">

<a mat-button *ngIf="!simple" routerLink="/">Home</a>
<a mat-button *ngIf="!simple" routerLink="/stream">News</a>
<a mat-button *ngIf="!simple" routerLink="/About">About</a>
<a mat-button *ngIf="!simple" routerLink="/Contact">Contact</a>
<a mat-button *ngIf="!simple" routerLink="/Support">Support</a>